import React, { FC } from 'react';
import {
  ContributorsDetailsModal,
  PeriodType,
} from '@devd-client/devd/components';
import { useContributorDetailInfinteGql } from '../../graphql';
import { getRole } from '@devd-client/devd/auth';

interface SlideDrawerProps {
  openDrawer: boolean;
  handleDrawerClose: () => void;
  team: string;
  selected: PeriodType;
}

const SlideDrawer: FC<SlideDrawerProps> = ({
  openDrawer,
  handleDrawerClose,
  team,
  selected,
}) => {
  const {
    data: contributorData,
    isLoading: contributorLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useContributorDetailInfinteGql(
    selected.startDate,
    selected.endDate,
    selected?.sprintId,
    team,
    getRole(),
    20
  );

  return (
    <ContributorsDetailsModal
      openDrawer={openDrawer}
      handleDrawerClose={handleDrawerClose}
      team={team!}
      contributorData={contributorData}
      loading={contributorLoading}
      repoTitle={false}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};

export default React.memo(SlideDrawer);
